<template>
  <Block tagName="div" type="onestoreSubscribePrivacy">
    <a class="subscribe-privacy j-subscribe-privacy" @click="jumpPrivacyLink">{{
      languages.onestore_subscribe_privacy
    }}</a>
  </Block>
</template>
<script>
import bridge from '@utiles/bridge';
import { mapState } from 'vuex';
export default {
  props: ['privacyLink'],
  computed: {
    ...mapState({
      languages: state => state.onestoreSubscribe.languages,
    }),
  },
  methods: {
    jumpPrivacyLink() {
      bridge.callSdkMethod('openBrowser', {
        url: this.privacyLink,
        loginDir: 0,
        appendParams: 0,
      });
    },
  },
};
</script>
